import { CompositeRow } from '@ariakit/react/composite';
import { MenuItemRadio } from '@ariakit/react/menu';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import type { MenuItem } from 'types/capi/plp';

import { useIsDropdownOpen } from '../Dropdown';
import type { FacetSelection } from './Menus';

const COLUMNS = 4;

const SizeFilterGrid = ({
  items = [],
  menuId,
  onOptionSelect,
  sizeRegion
}: {
  items?: MenuItem[];
  menuId: string;
  onOptionSelect: (selection: FacetSelection) => void;
  sizeRegion: string;
}) => {
  const { t } = useTranslation('plp');
  const isOpen = useIsDropdownOpen();

  const rows = items.reduce<MenuItem[][]>((grouped, item, index) => {
    if (index % COLUMNS === 0) grouped.push([]);
    grouped[grouped.length - 1]?.push(item);

    return grouped;
  }, []);

  return (
    <div className="flex w-full flex-col gap-3 p-4">
      <p className="text-sm text-grey-hide">
        {t('sizeWithRegion', { region: sizeRegion })}
      </p>
      {rows.map((row, index) => (
        <CompositeRow
          className="grid grid-cols-[repeat(4,minmax(60px,1fr))] gap-2 min-[375px]:grid-cols-[repeat(4,minmax(72px,1fr))]"
          key={`size-row-${index}`}
        >
          {row.map((item) => {
            const className = `rounded-full p-2 text-center text-sm ${
              item.active
                ? 'bg-black text-white'
                : 'border border-grey-divide text-black'
            }`;

            if (!isOpen) {
              return (
                <Link
                  className={className}
                  data-cy="size-filter-option"
                  key={`size-${item.text}`}
                  rel="nofollow"
                  to={item.path}
                >
                  {item.text}
                </Link>
              );
            }

            return (
              <MenuItemRadio
                checked={Boolean(item.active)}
                className={className}
                key={`size-${item.text}`}
                name={menuId}
                onClick={() => onOptionSelect(item)}
                render={
                  <Link
                    data-cy="size-filter-option"
                    to={item.path}
                    rel="nofollow"
                  />
                }
                value={item.value ?? item.text}
              >
                {item.text}
              </MenuItemRadio>
            );
          })}
        </CompositeRow>
      ))}
    </div>
  );
};

export default SizeFilterGrid;
